import { type } from "arktype";

export const AddressSearchSchema = type({
	value: "string",
	label: "string",
	description: "string",
	context: "string",
	highlights: type(["number", "number"]).array(),
});

export const AddressSearchResourceSchema = type({
	data: AddressSearchSchema,
	links: {
		self: "string",
		"continue-search?": "string|null",
		"details?": "string|null",
	},
});
export const AddressSearchResourceListSchema = type({
	data: AddressSearchResourceSchema.array(),
	session: "string",
});

export const AddressDetails = type({
	country: "string",
	city: "string",
	street: "string",
	postcode: "string",
	house_number: "number",
	extension: "string|null",
	municipality: "string",
	province: "string",
});

export const AddressDetailsResourceSchema = type({
	address: AddressDetails,
	"postcode?": {
		postcode: "string = ''",
		neighbourhoodCode: "string = ''",
		letterCombination: "string = ''",
	},
	mail_lines: "string[]",
	is_po_box: "boolean | null = false",
});

export const ZipcodeResourceSchema = type({
	data: {
		postcode: "string",
		house_number: "number",
		extension: "string|null",
		city: "string",
		street: "string",
		municipality: "string",
		province: "string",
		country: "string",
		formattedAddress: "string[]",
	},
});

export type AddressSearch = typeof AddressSearchSchema.infer;
export type AddressSearchResource = typeof AddressSearchResourceSchema.infer;
export type AddressSearchResourceList = typeof AddressSearchResourceListSchema.infer;
export type AddressDetails = typeof AddressDetails.infer;
export type AddressDetailsResource = typeof AddressDetailsResourceSchema.infer;
export type ZipcodeResource = typeof ZipcodeResourceSchema.infer;
